import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22.382}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24011 27571"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528237928672">
        <path
          d="M8265 8013h7481l770-1543c73-145 223-238 385-238h6247V862H862v5370h6247c163 0 311 93 384 238l772 1543zm7747 861H7999c-164 0-313-92-386-238l-771-1542H430c-237 0-430-193-430-431V431C0 193 193 0 430 0h23149c238 0 431 193 431 431l1 6232c0 238-194 431-432 431h-6411l-771 1542c-74 146-222 238-385 238z"
          className="fil0"
        />
        <path
          d="M21798 24901H2212c-238 0-432-193-432-431V6663c0-238 193-431 431-431s431 193 431 431l1 17376h18725V6663c0-238 193-431 430-431 238 0 431 193 431 431v17807c0 238-193 431-431 431z"
          className="fil0"
        />
        <path
          d="M862 26710h22286v-1809H862v1809zm22717 861H430c-237 0-430-193-430-431v-2670c0-238 193-431 430-431h23149c238 0 431 193 431 431l1 2670c0 238-194 431-432 431zM9765 9793h4480v-919H9765v919zm4911 862H9334c-238 0-431-193-431-431V8445c0-239 193-432 431-432h5342c238 0 431 193 431 432v1779c0 238-194 431-431 431z"
          className="fil0"
        />
        <path
          d="M11043 12910h1924l322-2255h-2568l322 2255zm2297 861h-2671c-214 0-396-157-426-369l-445-3117c-18-123 19-248 100-343 82-95 202-149 326-149h3562c124 0 243 55 325 148 82 96 119 221 101 344l-445 3116c-31 213-212 370-427 370zM8874 24039h6261v-6261H8874v6261zm6692 862H8443c-238 0-431-193-431-431v-7123c0-238 193-431 431-431h7123c238 0 431 193 431 431v7123c0 238-193 431-431 431z"
          className="fil0"
        />
        <path
          d="M15997 19113v2672c1024-165 1810-1055 1810-2126v-546h-1810zm-345 3562h-86c-238 0-431-193-431-431v-3562c0-238 193-431 431-431h2671c238 0 431 193 431 431v977c0 1663-1352 3016-3016 3016zM12005 20004c-499 0-905 405-905 904 1 499 406 905 905 905s905-406 905-905-406-904-905-904zm0 2671c-974 0-1767-793-1767-1767s793-1766 1767-1766 1766 792 1766 1766-792 1767-1766 1767zM12005 15107c-238 0-432-193-432-431l1-1335c0-238 192-431 431-431 238 0 430 193 430 431l1 1335c0 238-194 431-431 431zM12005 17778c-238 0-432-193-432-431l1-891c0-238 192-430 431-430 238 0 430 192 430 430l1 891c0 238-194 431-431 431zM12005 2642c-990 0-1795 805-1795 1795s805 1795 1795 1795 1795-805 1795-1795-805-1795-1795-1795zm0 4452c-1465 0-2656-1192-2656-2657s1191-2655 2656-2655c1465-1 2657 1190 2657 2655s-1192 2657-2657 2657zM2643 4006h3589v-919H2643v919zm4020 862H2212c-238 0-432-193-432-431V2657c0-238 193-431 431-431h4452c238 0 431 193 431 431v1780c0 238-193 431-431 431zM20449 4006h919v-919h-919v919zm1349 862h-1780c-238 0-431-193-431-431V2657c0-238 193-431 431-431h1780c238 0 431 193 431 431v1780c0 238-193 431-431 431zM16887 4006h920v-919h-920v919zm1350 862h-1780c-239 0-432-193-432-431V2657c0-238 193-431 432-431h1780c238 0 431 193 431 431v1780c0 238-193 431-431 431z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
